
import { BaseBox, PrimaryButton } from '@docon/docon-ui-library';
import React from 'react';
import styled, { css } from 'styled-components';
import Image from './Image';
import { dismissWebView } from 'utils/webview/webview';
import { useSelector } from 'react-redux';

const Container = styled(BaseBox)`
width: 100%;
height: 100vh;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
`;

const ErrorText = styled.p`
  margin-top: 16px;
`;

const Button = styled(PrimaryButton)`
  height: 32px;
  width: 100px;
  margin-left: auto;
  margin-right:auto;
  margin-top: 16px;
  border-radius: 4px;
`;
const ErrorComponent = () => {
  const { isWebView } = useSelector(state => state.app);
  const handleGoBack = () => {
    if (isWebView) {
      dismissWebView();
    }
  };
  return <Container>
    <Image src='https://cdn.pharmeasy.in/cms/homepage_assets/appleErrorImage.svg' alt='error-image' width={150} height={150} ignoreAssetsPath={true} />
    <ErrorText>Something went wrong!</ErrorText>
    <Button onClick={handleGoBack}>Go Back</Button>
  </Container>;
};

export default ErrorComponent;